export const quickLinks = [
  {
    linkText: 'Pay Council Tax online',
    externalHref:
      'https://www.westminster.gov.uk/council-tax/how-pay-your-council-tax',
    openInNewTab: true,
  },
  {
    linkText: 'View or apply for Free school meals',
    externalHref: window.origin + '/mwdc/freeschoolmeals/fsm-dashboard',
    openInNewTab: true,
  },
  {
    linkText: 'Apply for MyWestminster Digital Card',
    externalHref: window.origin + '/mwdc/dashboard',
    openInNewTab: true,
  },
  {
    linkText: 'Book a Bulky Waste Collection',
    externalHref:
      'https://www.westminster.gov.uk/recycling-and-rubbish/recycling-and-rubbish-collections/how-dispose-bulky-waste',
    openInNewTab: true,
  },
];
